/**
 * Hooks for ACL
 */
import React, { useState } from 'react'
import type { Category } from '@/types/acl'
import type { User } from '@/types/user'

export const useCategories = () => {
	const [categories, setCategories] = useState<Category[]>([])
	const [isLoading, setIsLoading] = useState<boolean>(false)

	React.useEffect(() => {
		setIsLoading(true)
		// fetch categories
		fetch(`${process.env.REACT_APP_API_URL}/acl/categories`)
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					setCategories(data.data.categories)
				}
			})
			.finally(() => {
				setIsLoading(false)
			})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return { categories, isLoading }
}

export const fetchUser = async () => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/users/me`)
		const data = await response.json()

		if (data.success) {
			return data.data.user as User
		} else {
			throw new Error(data.message)
		}
	} catch (error) {
		throw error
	}
}

export const logoutUser = async () => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`)
		const data = await response.json()

		if (data.success) {
			// remove token from local storage
			localStorage.removeItem('token')
			return true
		} else {
			throw new Error(data.message)
		}
	} catch (error) {
		throw error
	}
}

export const fetchUserPermissions = async (userId: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/users/${userId}/permissions`)
		const data = await response.json()

		if (data.success) {
			return {
				permissions: data.data.permissions,
				roles: data.data.roles,
			}
		} else {
			throw new Error(data.message)
		}
	} catch (error) {
		throw error
	}
}

export const fetchRoles = async () => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/acl/roles`)
		const data = await response.json()

		if (data.success) {
			return data.data
		} else {
			throw new Error(data.message)
		}
	} catch (error) {
		throw error
	}
}

export const fetchPermissions = async ({ type = 'flat' }: { type: 'flat' | 'nested' | 'category' }) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/acl/permissions?type=${type}`)
		const data = await response.json()

		if (data.success) {
			return data.data.categories as Category[]
		} else {
			throw new Error(data.message)
		}
	} catch (error) {
		throw error
	}
}
